<template>
  <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehouse_associated_doc')">
          <a-radio-group
            v-decorator="[
              'isPlan',
              {
                initialValue: 0,
                rules: [{ required: true, message: $t('page_material_warehouse_select_whether') }]
              }
            ]"
            @change="changePlan"
          >
            <a-radio :value="1">
              {{ $t('yes') }}
            </a-radio>
            <a-radio :value="0">
              {{ $t('no') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehouse_odd_numbers')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'planCode',
              { rules: [{ required: comformDefa.isPlan, message: $t('please_select') + $t('单号') }] }
            ]"
            :disabled="!comformDefa.isPlan"
            showSearch
            :placeholder="$t('please_select') + $t('page_material_warehouse_odd_numbers')"
            @change="handleChangePlan"
          >
            <template v-for="(item, index) in comformDefa.planList">
              <a-select-option :key="index" :value="item.code">
                {{ item.code }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_system_coding_rules')">
          <a-select
            style="width: 100%"
            show-search
            optionFilterProp="children"
            v-decorator="['codeRuleId']"
            :placeholder="$t('please_select') + $t('page_system_coding_rules')"
            :allowClear="true"
          >
            <a-select-option :value="item.value" v-for="(item, index) in codeList" :key="index">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_code')">
          <div>
            <a-input
              style="width: 100%"
              :disabled="codeRule != undefined"
              :placeholder="$t('common_please_input') + $t('page_material_warehousing_code')"
              v-decorator="['orderCode']"
            />
          </div>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_name')">
          <a-input
            style="width: 100%"
            v-decorator="['orderName', { max: 48 }]"
            :placeholder="$t('common_please_input') + $t('page_material_warehousing_name')"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_delivery_no')">
          {{ $t('page_material_warehousing_automatic') }}
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_feeding_ren')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['deliveryUser']"
            @change="handleSelectChange"
            :placeholder="$t('please_select') + $t('page_material_warehousing_feeding_ren')"
          >
            <a-select-option v-for="s in staff" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_code')">
          {{ $t('page_material_warehousing_automatic') }}
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_dept')">
          <a-tree-select
            v-decorator="['receivingDept']"
            :treeData="depts"
            tree-default-expand-all
            show-search
            tree-node-filter-prop="title"
            @change="handleReceivingDeptName"
            :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_dept')"
          >
          </a-tree-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_ren')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'receivingUser',
              {
                rules: [{ required: true, message: $t('page_material_warehousing_p_select') }]
              }
            ]"
            :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_ren')"
            @change="handleReceivingUser"
          >
            <a-select-option v-for="s in staff" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('supplier')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['supplierId']"
            @change="handleSupplierName"
            :placeholder="$t('please_select') + $t('supplier')"
          >
            <a-select-option v-for="s in supplierList" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_ware_out_code')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'outOrderCode',
              {
                rules: [
                  {
                    required: comformDefa.isPlan,
                    message: $t('page_material_warehousing_p_select')
                  }
                ]
              }
            ]"
            :placeholder="$t('please_select') + $t('page_material_ware_out_code')"
            allowClear
            @change="(value) => handleChangeOutOrder(value)"
          >
            <a-select-option v-for="s in stockOutOrderList" :key="s.orderCode" :value="s.orderCode">
              {{ s.orderCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { StockOutOrderServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
const whasp = new WarehouseAreaServiceProxy()
const soosp = new StockOutOrderServiceProxy()

import form from './form.js'
export default {
  mixins: [form],
  data() {
    return {
      form: this.$form.createForm(this),
      codeList: [],
      supplierList: [],
      stockOutOrderList: [],
      deliveryUserName: '',
      receivingUserName: '',
      supplierName: '',
      planListF: []
    }
  },
  props: {
    staff: {
      type: Array,
      default: () => []
    },
    depts: {
      type: Array,
      default: () => []
    },
    inTypeCode: {
      type: String,
      default: ''
    }
  },
  methods: {
    getMaterialPlanList() {
      whasp.getTpmRepairAndMaintainNumber().then((res) => {
        console.log(res)
        this.comformDefa.planList = res
        this.planListF = res
      })
    },
    // 关联计划
    changePlan(value) {
      this.changeReast()
      this.comformDefa.selectPlan = ''
      if (value.target.value === 1) {
        this.comformDefa.isPlan = true
        this.stockOutOrderList = []
        this.getMaterialPlanList()
      } else {
        this.form.setFieldsValue({
          planCode: ''
        })
        this.getStockOutOrder()
        this.planListF = []
        this.comformDefa.isPlan = false
      }
      this.form.setFieldsValue({
        outOrderCode: ''
      })
      this.$emit('changDefa', this.comformDefa)
    },
    save(value, callback) {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.comformDefa.isPlan) {
            const plan = this.comformDefa.planList.find(
              (res) => res.code === this.comformDefa.selectPlan
            )
            values.planCode = this.comformDefa.selectPlan
            values.planId = plan ? plan.id : ''
            values.bizType = plan ? plan.type : ''
          }
          const data = { ...values, ...value }
          callback(data)
        } else {
          callback(false)
        }
      })
    },
    handleChangePlan(value) {
      // this.changeReast()
      this.getMaterialPlanList()
      this.comformDefa.selectPlan = value
      if (this.comformDefa.selectPlan && this.inTypeCode) {
        this.getStockPlanOrder()
      } else {
        this.getStockOutOrder()
      }
      this.form.setFieldsValue({
        outOrderCode: ''
      })
      this.$emit('changDefa', this.comformDefa)
    },
    getStockPlanOrder() {
      this.stockOutOrderList = []
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      soosp.pageStockOutOrderByType(areaId, 1, '', 999999).then((res) => {
        this.stockOutOrderList = res.records
      })
    }
  }
}
</script>
<style scoped></style>
